import { If } from 'components';
import { LineItem } from 'containers/invoices/invoices.model';
import React, { FC } from 'react';
import { getAmountWithCurrency } from 'utils/amountUtils';

interface LineItemSectionProps {
  lineItems: LineItem[];
  discount: string;
  totalAmount: string;
  payableAmount: string;
}

const LineItemsSection: FC<LineItemSectionProps> = ({ lineItems, totalAmount, payableAmount, discount }) => {
  const taxesAndFees = +totalAmount - +payableAmount;

  // eslint-disable-next-line react/no-multi-comp
  const LineItemTile = ({ lineItem }: { lineItem: LineItem }) => (
    <div className="mb-2 flex flex-col gap-y-2">
      <div className="flex items-start justify-between">
        <div className="w-[70%] break-words text-sbase font-semibold text-primaryText">{lineItem.name}</div>
        <div className="text-right text-sbase font-semibold text-primaryText">
          {getAmountWithCurrency(lineItem.amount)}
        </div>
      </div>
      <div className="flex items-start justify-between">
        <div className="text-px13 font-semibold text-accentText">
          {`(${lineItem.qty} x ${getAmountWithCurrency(lineItem.unitPrice)})`}
        </div>
        {lineItem.taxes?.length > 0 && (
          <div className="text-right text-px13 font-semibold text-accentText">{`+${lineItem.taxes.length} taxes`}</div>
        )}
      </div>
    </div>
  );

  return (
    <div className="flex flex-col gap-y-2">
      <div className="text-sbase font-bold text-primaryText">Line items ({lineItems?.length})</div>
      <div className="rounded-md border border-borderGray pt-4">
        <div className="px-4">
          {lineItems?.map((lineItem, index) => (
            <div key={lineItem.id}>
              {index > 0 && <div className="mb-2 w-full border-b border-secondaryBtn" />}
              <LineItemTile key={lineItem.catalogueLineItemId} lineItem={lineItem} />
            </div>
          ))}
          <If condition={Boolean(+discount)}>
            <div className={'flex justify-between py-2 text-sbase font-semibold text-tertiaryText'}>
              <div>Discount</div>
              <div id="line-item-discount" className="flex gap-4 text-right">
                <div>-{getAmountWithCurrency(discount)}</div>
              </div>
            </div>
          </If>
        </div>
        <div className="flex items-center justify-between bg-blue-2 p-4">
          <div className="text-17px font-semibold text-primaryText">Subtotal</div>
          <div className="text-right text-17px font-semibold text-primaryText">
            {getAmountWithCurrency(payableAmount)}
          </div>
        </div>
        <div className="flex items-center justify-between bg-white p-4">
          <div className="text-sbase font-semibold text-primaryText">Taxes and fees</div>
          <div className="text-right text-sbase text-black">{getAmountWithCurrency(taxesAndFees)}</div>
        </div>
        <div className="flex items-center justify-between rounded-b-md bg-blue-2 p-4">
          <div className="text-17px font-bold text-headingGray">Total amount</div>
          <div className="text-heaingGray text-right text-17px font-semibold">{getAmountWithCurrency(totalAmount)}</div>
        </div>
      </div>
    </div>
  );
};

export default LineItemsSection;
